export default function Reset() {
  function resetNewsletter() {
    const newsletter = document.querySelector("#newsletter");
    newsletter?.setAttribute("data-success", "false");

    const inputs = newsletter?.querySelectorAll("input");
    inputs?.forEach((input) => input.value = "");
  }

  return (
    <button
      class="w-full max-w-[17.5rem] h-12 rounded-lg bg-tw-primary-100 text-white text-xl font-bold z-10 transition-colors hover:bg-tw-primary-200"
      onClick={resetNewsletter}
    >
      Voltar
    </button>
  );
}
